var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.elementStyles),attrs:{"id":"vp-status"}},[_c('div',{class:['vp-status__output', _vm.state]},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.text && _vm.text.toLowerCase() || _vm.state))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }